import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Services/Common/errorApiHandleUtils";
import { checkFilter } from "Services/Common/filterUtils";
import { userService } from "Services/Axios/userService";

export const getUser = createAsyncThunk(
    'user/getUser',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await userService.getUser(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const exportUsers = createAsyncThunk(
    'order/exportOrders',
    async (filters, { rejectWithValue }) => {
        try {
            const filter = checkFilter(filters);
            const response = await userService.exportUser(filter);

            // Blob handling
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'export-user-qeza-app.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
